import * as THREE from 'three'

class RoundedPlane extends THREE.Mesh {

    constructor({ height, width, radius, opacity, color, map }) {

        const x = -width / 2, y = -height / 2

        const shape = new THREE.Shape();
        shape.moveTo(x, y + radius);
        shape.lineTo(x, y + height - radius);
        shape.quadraticCurveTo(x, y + height, x + radius, y + height);
        shape.lineTo(x + width - radius, y + height);
        shape.quadraticCurveTo(x + width, y + height, x + width, y + height - radius);
        shape.lineTo(x + width, y + radius);
        shape.quadraticCurveTo(x + width, y, x + width - radius, y);
        shape.lineTo(x + radius, y);
        shape.quadraticCurveTo(x, y, x, y + radius);

        const geometry = new THREE.ShapeBufferGeometry(shape);
        const material = new THREE.MeshBasicMaterial({
            color: color || 'rgb(20, 20, 20)',
            side: THREE.DoubleSide,
            transparent: true,
            opacity: opacity || 1,
            alphaTest: 0.5,
            map: map ? map : null
        });
        // material.depthWrite = false
        // material.depthTest = false
        super(geometry, material);
        this.renderOrder = 90
    }

    setColor(color) {
        if (this.color === color) {
            return
        }
        this.color = color
        const material = this.material
        material.color = new THREE.Color(color);
    }
}

export default RoundedPlane